import React, { useState } from "react";

export default function Carousel({ items = [] }) {
  const [index, setIndex] = useState(0);

  const prev = () => setIndex((index - 1 + items.length) % items.length);
  const next = () => setIndex((index + 1) % items.length);

  return (
    <div className="w-full bg-[#0346A4] py-10 px-10 md:px-20 text-white">
      <h2 className="text-center font-bold mb-8 text-[#E8F2F4] text-3xl">¿Cómo es el proceso de activación?</h2>
      <div className="relative  w-full mx-auto">
        {index > 0 && (
          <button onClick={prev} className="absolute left-0 top-1/2 -translate-y-1/2 bg-white text-[#003c9e] font-bold px-3 py-1 rounded-full shadow-md z-10">
            ‹
          </button>
        )}
        <div className="flex  justify-center">
          <div className="flex transition-transform duration-500 ease-in-out" style={{ transform: `translateX(-${index * 20}%)` }}>
            {items.map((item, i) => (
              <div key={i} className="flex-shrink-0 w-full md:w-1/3 lg:w-1/5 bg-[#e8f2f4] rounded-xl shadow-md mx-4 p-6 text-center text-[#003c9e]">
                <h3 className="text-md font-bold mb-4">{item.titulo}</h3>
                <img src={item.imagen} alt="" className="w-12 h-12 mx-auto mb-4" />
                <p className="text-sm font-semibold">{item.descripcion}</p>
              </div>
            ))}
          </div>
        </div>
        {index + 3 < items.length && (
          <button onClick={next} className="absolute right-0 top-1/2 -translate-y-1/2 bg-white text-[#003c9e] font-bold px-3 py-1 rounded-full shadow-md z-10">
            ›
          </button>
        )}
      </div>
    </div>
  );
}
